export default "__VITE_ASSET__Bw8nSWos__"